import { LoadableElement } from '@99designs/common/components/LoadableElement';
import {
    InviteDesignersPage,
    InviteDesignersPageVariables,
} from '__generated__/InviteDesignersPage';
import { Viewer } from '__generated__/Viewer';
import Bugsnag from 'common/utils/Bugsnag';
import DesignerResults from 'projects/components/DesignerResults';
import { trackViewedBriefEvent } from 'projects/events';
import * as React from 'react';
import { Query } from 'react-apollo';
import { history } from './BrowserRouter';
import { BriefType, routes } from './index';
import InviteDesignersPageQuery from './InviteDesignersPage.graphql';

export interface Props {
    viewer: Viewer;
    brief: BriefType & {
        designers: { id: number; displayName: string }[];
        category?: {
            key: string;
            title: string;
        } | null;
    };
    children?: React.ReactNode;
}

export default class InviteDesigners extends React.Component<Props> {
    componentDidMount() {
        const user = this.props.viewer.user;

        if (!user) {
            history.push(routes.brief(this.props.brief, 1));
        }

        trackViewedBriefEvent({
            id: this.props.brief.id,
            page: 'InviteDesigners',
        });
    }

    render() {
        const { brief } = this.props;
        return (
            <>
                <Query<InviteDesignersPage, InviteDesignersPageVariables>
                    query={InviteDesignersPageQuery}
                    variables={{ id: brief.id }}
                    fetchPolicy="network-only"
                >
                    {({ loading, data, error }) => {
                        if (loading) {
                            return <LoadableElement isLoading={true} variations={['relative ']} />;
                        }

                        if (error) {
                            throw error;
                        }

                        if (!data || !data.brief) {
                            return <>{__('Not Found')}</>;
                        }

                        if (!data.brief.relevantDesigners) {
                            Bugsnag.notify({
                                errorClass: 'NoMatchingDesigners',
                                errorMessage: `Brief ${
                                    data.brief.id
                                } does not have any matching designers `,
                            });
                            return <>{__('No results')}</>;
                        }

                        return (
                            <>
                                <div className="content-setting content-setting--full">
                                    <div className="paragraph paragraph--soft paragraph--centered paragraph--double-margin">
                                        {this.props.children}
                                    </div>
                                    <DesignerResults brief={data.brief} />
                                </div>
                            </>
                        );
                    }}
                </Query>
            </>
        );
    }
}
